import Masonry from 'masonry-layout';

const masonryElement = document.querySelector('.post-archive__masonry');

if (masonryElement) {
	const masonry = new Masonry('.post-archive__masonry',
		{
			gutter: 32,
			itemSelector: '.post-archive__masonry__item',
			columnWidth: '.post-archive__masonry__item',
			percentPosition: true,
		},
	);

	document.addEventListener('facetwp-loaded', () => {
		masonry.reloadItems();
		masonry.layout();
	});
}
